/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import MogomaLogo from "../../assets/img/logo.png";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function SidebarResponsive(props) {
  let location = useLocation();
  const [state, setState] = React.useState({});
  const mainPanel = React.useRef();

  const userId = useSelector((state) => state.auth?.user?.user?.user_id);
  const allChats = useSelector((state) => state.chat?.allChats || []);

  const messagingCount = React.useMemo(() => {
    if (!userId || !Array.isArray(allChats)) return 0;

    return allChats.filter((chatItem) => {
      const chat = chatItem?.chat || chatItem;

      return (
        chat?.receiver_id === userId &&   
        chat?.sender_id !== userId &&    
        chat?.status === "sent"        
      );
    }).length;
  }, [allChats, userId]);

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const gradientBlue1 = "#071D54";
  const gradientBlue2 = "#1E3A8A";

  const createLinks = (routes) => {
    const activeBg = useColorModeValue("white", "gray.700");
    const inactiveBg = useColorModeValue("white", "gray.700");
    const activeColor = useColorModeValue(gradientBlue2, "white");
    const inactiveColor = useColorModeValue("gray.400", "gray.400");

    return routes.map((prop) => {
      if (prop.redirect) return null;

      if (prop.category) {
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{ xl: "12px" }}
              mx="auto"
              ps={{ sm: "10px", xl: "16px" }}
              py="12px"
            >
              {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }

      if (prop.visible === false) return null;

      const isActive = activeRoute(prop.layout + prop.path) === "active";
      const isMessaging = prop.path === "/messages" && prop.layout === "/admin";
      const badgeValue = isMessaging ? messagingCount : 0;

      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          <Button
            boxSize="initial"
            justifyContent="space-between"
            alignItems="center"
            bg={isActive ? activeBg : "transparent"}
            mb={{ xl: "12px" }}
            mx={{ xl: "auto" }}
            ps={{ sm: "10px", xl: "16px" }}
            pe={{ sm: "10px", xl: "16px" }}
            py="12px"
            borderRadius="15px"
            _hover="none"
            w="100%"
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            <Flex align="center">
              {typeof prop.icon === "string" ? (
                <Icon color="inherit">{prop.icon}</Icon>
              ) : (
                <IconBox
                  bg={isActive ? gradientBlue2 : inactiveBg}
                  color={isActive ? "white" : gradientBlue2}
                  h="30px"
                  w="30px"
                  me="12px"
                >
                  {prop.icon}
                </IconBox>
              )}
              <Text
                color={isActive ? activeColor : inactiveColor}
                my="auto"
                fontSize="sm"
              >
                {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
              </Text>
            </Flex>

            {badgeValue > 0 && (
              <Box
                bg="red.500"
                color="white"
                borderRadius="full"
                minW="20px"
                h="20px"
                px="6px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="xs"
              >
                {badgeValue}
              </Box>
            )}
          </Button>
        </NavLink>
      );
    });
  };

  const { logoText, routes, ...rest } = props;

  var links = <>{createLinks(routes)}</>;
  let hamburgerColor = useColorModeValue("gray.500", "gray.200");
  if (props.secondary === true) {
    hamburgerColor = "white";
  }

  var brand = (
    <Box pt={"35px"} mb="8px">
      <Link
        href={`${process.env.PUBLIC_URL}/#/`}
        target="_blank"
        display="flex"
        lineHeight="100%"
        mb="30px"
        fontWeight="bold"
        justifyContent="center"
        alignItems="center"
        fontSize="11px"
      >
        <img
          src={MogomaLogo}
          alt="Mogoma Logo"
          style={{ width: "100px", height: "22px", marginRight: "10px" }}
        />
      </Link>
      <Separator />
    </Box>
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Flex display={{ sm: "flex", xl: "none" }} ref={mainPanel} alignItems="center">
      <HamburgerIcon
        color={hamburgerColor}
        w="18px"
        h="18px"
        ref={btnRef}
        onClick={onOpen}
      />
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent
          w="250px"
          maxW="250px"
          ms={{ sm: "16px" }}
          my={{ sm: "16px" }}
          borderRadius="16px"
        >
          <DrawerCloseButton _focus={{ boxShadow: "none" }} _hover={{ boxShadow: "none" }} />
          <DrawerBody maxW="250px" px="1rem">
            <Box maxW="100%" h="100vh">
              <Box>{brand}</Box>
              <Stack direction="column" mb="40px">
                <Box>{links}</Box>
              </Stack>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;
